const about = {
  pageTitle: "关于我们 - 51吃瓜网",
  pageDescription: "了解51吃瓜网品牌故事、平台特色与联系方式。正能量不打烊，爆料第一线。",
  hero: {
    label: "关于我们",
    title1: "正能量不打烊",
    title2: "爆料第一线",
    description: "51吃瓜网成立于2020年，致力于打造国内最专业、最全面的娱乐资讯平台。我们坚持客观公正的报道原则，为每一位吃瓜群众提供最新、最全、最真实的娱乐动态。",
    missionTitle: "品牌使命",
    missionText: "\"让每一个热爱娱乐的人，都能第一时间吃到最新鲜的瓜。我们不做谣言的制造者，只做真相的搬运工。\"",
    founderName: "吃瓜君",
    founderTitle: "51吃瓜网创始人 & 总编辑",
  },
  featuresSection: {
    label: "平台特色",
    title1: "为什么选择",
    title2: "51吃瓜网",
    description: "五大核心优势，为您提供最优质的吃瓜体验。",
  },
  features: [
    {
      icon: "ri-flashlight-line",
      title1: "极速更新",
      title2: "实时追踪",
      description: "7×24小时全天候监控娱乐圈动态，第一时间为您送上最新鲜的瓜。",
    },
    {
      icon: "ri-shield-check-line",
      title1: "多重核实",
      title2: "真实可靠",
      description: "每条爆料都经过至少三个独立信息源的交叉验证，确保内容真实可信。",
    },
    {
      icon: "ri-eye-line",
      title1: "深度挖掘",
      title2: "独家视角",
      description: "资深娱记团队深入一线，为您带来普通媒体看不到的独家内幕。",
    },
    {
      icon: "ri-group-line",
      title1: "千万瓜友",
      title2: "一起交流",
      description: "活跃的评论区社区，和千万吃瓜群众一起讨论最热门的娱乐话题。",
    },
  ],
  contactSection: {
    title: "商务合作与爆料投稿",
    subtitle: "欢迎品牌方洽谈合作，也欢迎知情人士提供爆料线索。",
    button: "联系我们",
  },
  structuredData: {
    webpageName: "关于我们 - 51吃瓜网",
    webpageDescription: "了解51吃瓜网品牌故事、平台特色与联系方式。",
  },
};

export default about;